/* eslint-disable @typescript-eslint/naming-convention */
import loading from '../components/loading/loading.vue';
import load from './core/load';
const _loading = load(loading, void 0, 'loading');

type ShowLoadingParams = {
  pageLoading: boolean
}

function showLoading(params?: ShowLoadingParams) {
  params = params ? params : { pageLoading: false };
  _loading.show(params);
}

function hideLoading() {
  _loading.hide();
}

export { showLoading, hideLoading }